<template>
  <div class="tips">
     <h3 class="title-group">5、上传素材</h3>
     <div class="tips mb20">
        <p class="text-color-gray">创建说明：按照调用的智能投放类型计划的规格（图片、视频数量）匹配上传的创意，上传的创意数量大于一个计划规格数量时，将创建第二个计划，以此类推。</p>
    </div>
  </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.title-group{
    font-size: 14px;
    margin-bottom: 20px;
}
</style>